"use server";

const STRAPI = process.env.STRAPI_INTERNAL_URL ?? "http://strapi:1337";

export type ForgotState = { sent?: boolean; error?: boolean };

/** Reset-Mail anfordern; antwortet immer gleich (kein User-Enumeration-Leak). */
export async function forgotPasswordAction(
  _prev: ForgotState,
  formData: FormData
): Promise<ForgotState> {
  const email = ((formData.get("email") as string) || "").trim();
  if (!email) return { error: true };
  try {
    await fetch(`${STRAPI}/api/account/forgot`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
      cache: "no-store",
    });
  } catch {
    /* absichtlich gleiche Antwort — kein Hinweis, ob das Konto existiert */
  }
  return { sent: true };
}
